import { Injectable, Inject } from '@angular/core';
import { environment } from '../../environments/environment';

declare global {
  interface Window {
    fbq: any;
  }
}

@Injectable({
  providedIn: 'root'
})
export class MetaPixelService {
  private pixelId = (environment as any).metaPixelId;

  constructor() {
    this.initializePixel();
  }

  private initializePixel(): void {
    // if (environment.envName !== 'production' || !this.pixelId) return;
  
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('init', this.pixelId);
      // fire first PageView right away
      window.fbq('track', 'PageView');
    }
  }

  /**
   * Track a page view
   */
  trackPageView(): void {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'PageView');
    }
  }

  /**
   * Track a custom event
   * @param eventName - The name of the event to track
   * @param parameters - Optional parameters for the event
   */
  trackEvent(eventName: string, parameters?: any): void {
    if (typeof window !== 'undefined' && window.fbq) {
      if (parameters) {
        window.fbq('track', eventName, parameters);
      } else {
        window.fbq('track', eventName);
      }
    }
  }
}
